import type { TemplateFormField } from '@common/types/templateFormFields';

function isPipeDelimitedValue(value: unknown): value is string {
    return typeof value === 'string' && value.includes('|');
}

function pipeSegmentAt(value: string, contactIndex: number): string {
    return value.split('|')[contactIndex] ?? '';
}

export function createWrappedContactSlot(
    baseData: TemplateFormField[],
    contactIndex: number,
): TemplateFormField[] {
    const slot = structuredClone(baseData);

    if (contactIndex === 0) {
        return slot;
    }

    return slot.map((field) => {
        const sourceField = baseData.find(
            (item) => item.templateFormFieldId === field.templateFormFieldId,
        );
        const sourceValue = sourceField?.questionSchema?.value;

        if (isPipeDelimitedValue(sourceValue)) {
            field.questionSchema.value = pipeSegmentAt(sourceValue, contactIndex);
        } else {
            field.questionSchema.value = '';
        }

        return field;
    });
}

export function splitGroupedContactFieldsIntoStore(
    baseData: TemplateFormField[],
    maxSlots = 10,
): TemplateFormField[][] {
    if (!baseData.length) {
        return [];
    }

    const arr: TemplateFormField[][] = [];

    baseData.forEach((item) => {
        const value = item.questionSchema.value;

        if (isPipeDelimitedValue(value)) {
            const splitValues = value.split('|');

            splitValues.forEach((val, index) => {
                if (!arr[index]) {
                    arr[index] = createWrappedContactSlot(baseData, index);
                }

                arr[index] = arr[index].map((subItem) => {
                    if (subItem.templateFormFieldId === item.templateFormFieldId) {
                        subItem.questionSchema.value = val;
                    }
                    return subItem;
                });
            });
        } else if (!arr[0]) {
            arr[0] = createWrappedContactSlot(baseData, 0);
        }
    });

    const emptyBaseData = baseData.map((item) => ({
        ...item,
        questionSchema: {
            ...item.questionSchema,
            value: '',
        },
    }));

    while (arr.length < maxSlots) {
        arr.push(structuredClone(emptyBaseData));
    }

    return arr;
}
